import type { ComponentType } from 'react';
import { Language } from '../Domain/Account/Language';

type CampaignLandingModule = { default: ComponentType };

export type CampaignLoader = () => Promise<CampaignLandingModule>;

export interface CampaignDefinition {
	loader: CampaignLoader;
	defaultLanguage: Language;
}

const campaignDefinitions: Record<string, CampaignDefinition> = {
	santa25: {
		loader: () => import('./santa25/Santa25Landing'),
		defaultLanguage: Language.Polish,
	},
};

export interface ResolvedCampaign extends CampaignDefinition {
	code: string;
}

export function resolveCampaign(rawCode: string | null): ResolvedCampaign | null {
	if (!rawCode) return null;
	const normalizedCode = rawCode.trim().toLowerCase();
	const definition = campaignDefinitions[normalizedCode];
	if (!definition) return null;
	return { ...definition, code: normalizedCode };
}


